/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpService } from './http.service';

@Injectable()
export class AutomationApi {
  private readonly apiController: string = 'automation';

  constructor(private api: HttpService) { }

  getAutomationController(params: any): Observable<any> {
    const json = `{"location":
                  {"name":"${params.location}","soling":"${params.soling}","ktp":"${params.ktp}"}
                  }`;
    // console.log('json', json);
    const data = JSON.parse(json);
    return this.api.post(`${this.apiController}/${params.sn}`, data);
  }

  getAutomationsController(params: any): Observable<any> {
    const json = `{"location":
                  {"name":"${params.location}"}
                  }`;
    // console.log('json', json);
    const data = JSON.parse(json);
    return this.api.post(`${this.apiController}/`, data);
  }
  // getInverterTodayData(params: any): Observable<any> {
  //   // console.log('params', params);
  //   const now = new Date();
  //   const json = `{"location":
  //                 {"name":"${params.location}","soling":"${params.soling}","ktp":"${params.ktp}"},
  //                 "device":{"num":"${params.num}"},
  //                 "date":{"y":${now.getUTCFullYear()},"m":${now.getUTCMonth() + 1},"d":${now.getUTCDate()}},
  //                 "filter":{"orderBy":"ASC"}}`;
  //   // console.log('json', json);
  //   const data = JSON.parse(json);
  //   return this.api.post(`${this.apiController}/${params.num}/today`, data);
  // }

  // getTodayInvertersPacByKtpNum(params: any): Observable<any> {
  //   // console.log('params', params);
  //   const now = new Date();
  //   const json = `{"location":
  //                 {"name":"${params.location}","soling":"${params.soling}","ktp":"${params.ktp}"},
  //                 "date":{"y":${now.getUTCFullYear()},"m":${now.getUTCMonth() + 1},"d":${now.getUTCDate()}},
  //                 "filter":{"orderBy":"ASC"}}`;
  //   // console.log('json', json);
  //   const data = JSON.parse(json);
  //   return this.api.post(`${this.apiController}/ktp/${params.ktp}/pac`, data);
  // }

  // getTodayInvertersQacByKtpNum(params: any): Observable<any> {
  //   const now = new Date();
  //   const json = `{"location":
  //                 {"name":"${params.location}","soling":"${params.soling}","ktp":"${params.ktp}"},
  //                 "date":{"y":${now.getUTCFullYear()},"m":${now.getUTCMonth() + 1},"d":${now.getUTCDate()}},
  //                 "filter":{"orderBy":"ASC"}}`;
  //   // console.log('json', json);
  //   const data = JSON.parse(json);
  //   return this.api.post(`${this.apiController}/ktp/${params.ktp}/qac`, data);
  // }

  // getCurrentPower(params: any): Observable<string> {
  //   const now = new Date();
  //   const json = `{"location":
  //                 {"name":"${params.location}","soling":"${params.soling}","ktp":"${params.ktp}"},
  //                 "date":{"y":${now.getUTCFullYear()},"m":${now.getUTCMonth() + 1},"d":${now.getUTCDate()}},
  //                 "filter":{"orderBy":"ASC"}}`;
  //   // console.log('json', json);
  //   const data = JSON.parse(json);
  //   return this.api.post(`${this.apiController}/pv/current-power`, data);
  // }

  // getDailyEnergy(params: any): Observable<string> {
  //   const now = new Date();
  //   const json = `{"location":
  //                 {"name":"${params.location}","soling":"${params.soling}","ktp":"${params.ktp}"},
  //                 "date":{"y":${now.getUTCFullYear()},"m":${now.getUTCMonth() + 1},"d":${now.getUTCDate()}},
  //                 "filter":{"orderBy":"ASC"}}`;
  //   // console.log('json', json);
  //   const data = JSON.parse(json);
  //   return this.api.post(`${this.apiController}/pv/daily-energy`, data);
  // }

  // getDayPowerValues(params: any): Observable<any> {
  //   const now = new Date();
  //   const json = `{"location":
  //                 {"name":"${params.location}","soling":"${params.soling}","ktp":"${params.ktp}"},
  //                 "date":{"y":${now.getUTCFullYear()},"m":${now.getUTCMonth() + 1},"d":${now.getUTCDate()}},
  //                 "filter":{"orderBy":"ASC"}}`;
  //   // console.log('json', json);
  //   const data = JSON.parse(json);
  //   return this.api.post(`${this.apiController}/pv/day-power`, data);
  // }

  // getDaySolingPowerValues(params: any): Observable<any> {
  //   const now = new Date();
  //   const json = `{"location":
  //                 {"name":"${params.location}","soling":"${params.soling}","ktp":"${params.ktp}"},
  //                 "date":{"y":${now.getUTCFullYear()},"m":${now.getUTCMonth() + 1},"d":${now.getUTCDate()}},
  //                 "filter":{"orderBy":"ASC"}}`;
  //   // console.log('json', json);
  //   const data = JSON.parse(json);
  //   return this.api.post(`${this.apiController}/pv/day-soling-power`, data);
  // }


  list(): Observable<any[]> {
    return this.api.get(this.apiController);
  }
}
